<template>
  <v-expansion-panels v-model="panel" readonly>
    <v-expansion-panel @click="toggle">
      <v-expansion-panel-header :class="{ 'elevation-1': !captureMode }">
        <v-layout class="header" align-center ref="header">
          <v-icon class="mr-2" size="20" :class="{ complete: isComplete }" color="white">
            mdi-check
          </v-icon>
          <span class="color--nice-grey font-weight-black">{{ title }}</span>
        </v-layout>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pb-4 px-0">
        <!-- 내용 역역 -->
        <component
          :is="content"
          :loan="loan"
          :isOpen="isOpen"
          :isFocus="isFocus"
          @sign="$emit('sign', $event)"
          @update:isComplete="updateIsComplete"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isFocus: {
      type: Boolean,
      default: false,
    },
    isComplete: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: Function,
      requied: true,
    },
    loan: {
      type: Object,
    },
  },
  data() {
    return {
      panel: this.isOpen ? 0 : null,
    }
  },
  watch: {
    isOpen(v) {
      this.panel = v ? 0 : null
    },
  },
  computed: {
    ...mapState('ui', ['captureMode']),
  },
  methods: {
    ...mapMutations('ui', ['setShowErrorMode']),
    toggle() {
      this.$emit('update:isOpen', !this.isOpen)
    },
    updateIsComplete(isComplete) {
      this.$emit('update:isComplete', isComplete)

      if (isComplete) {
        this.setShowErrorMode(false)
        // 현재 영역 접기
        this.$emit('update:isOpen', false)
        this.$emit('complete')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.v-expansion-panels:not(:last-of-type) {
  margin-bottom: 20px;
}

.v-expansion-panel {
  &-header {
    min-height: 52px !important;
    background-color: #f4faff !important;
    border-radius: $border-radius-default !important;
    padding: 12px 20px;
    width: calc(100% - 30px);
    margin: 0 15px;
  }

  &::before {
    box-shadow: unset !important;
  }

  .header .v-icon {
    border-radius: 50%;
    padding: 2px;

    &:not(.complete) {
      background: #d7e1ea;
    }
    &.complete {
      background: $main-color-default;
    }
  }
}

::v-deep > .v-expansion-panel-content__wrap {
  padding: 0;
  display: flex;
  justify-content: center;
}
</style>
